export enum VehicleOwnershipStatus {
	Owner = 'Owner',
	Leasing = 'Leasing',
}
